"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Container = styled_components_1.default.div(() => ({
    position: "absolute",
    bottom: 0,
    right: 0,
    maxWidth: "100%",
    display: "flex",
    zIndex: 1,
}));
exports.ActionButton = styled_components_1.default.button `
  ${({ theme, disabled = false }) => (0, styled_components_1.css) `
    border: 0 none;
    padding: 4px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;

    color: ${theme.palette.text.default};
    background: ${theme.palette.background.default};

    font-size: 12;
    line-height: 16px;
    font-family: ${theme.typography.fontFamily};
    font-weight: 600;

    border-top: 1px solid ${theme.palette.border.default};
    border-left: 1px solid ${theme.palette.border.default};
    margin-left: -1;

    border-radius: 4px 0 0 0;

    &:not(:last-child) {
      border-right: 1px solid ${theme.palette.border.default};
    }

    & + * {
      border-left: 1px solid ${theme.palette.border.default};
      border-radius: 0;
    }

    ,
    &:focus {
      box-shadow: ${theme.shadows.boxShadow.input};
      outline: 0 none;
    }

    ${disabled &&
    (0, styled_components_1.css) `
      cursor: not-allowed;
      opacity: 0.5;
    `}
  `}
`;
/**
 * ActionBar shows 'action' buttons at bottom of element.
 *
 * Used in Code component to add copy button
 */
const ActionBar = (_a) => {
    var { actionItems } = _a, props = __rest(_a, ["actionItems"]);
    return (react_1.default.createElement(Container, Object.assign({}, props), actionItems.map(({ title, onClick, disabled = false }, index) => (
    // eslint-disable-next-line react/no-array-index-key
    react_1.default.createElement(exports.ActionButton, { key: index, onClick: onClick, disabled: disabled }, title)))));
};
exports.default = ActionBar;
//# sourceMappingURL=ActionBar.js.map